import {AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {FormControl, FormGroup} from '@angular/forms';
import {takeUntil} from "rxjs/operators";

@Component({
    standalone: false,
    selector: 'app-dialog-field-input-requirements-editor',
  templateUrl: './dialog-field-input-requirements-editor.component.html',
  styleUrls: ['./dialog-field-input-requirements-editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogFieldInputRequirementsEditorComponent extends DialogDefinitionEditorBase implements OnInit, AfterViewInit, OnDestroy {
  requiredValidators: string[] = [];
  isValidatorChecked = {};
  validatorInputValue = {};
  validatorForm: FormGroup;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.requiredValidators = this.dialogField.fieldValues['RequiredValidators'];
    const validatorValue = this.dialogField.value;
    this.requiredValidators.forEach(o => {
      if (validatorValue.hasOwnProperty(o)) {
        this.isValidatorChecked[o] = validatorValue[o];
        this.validatorInputValue[o] = '';
      }
    });

    this.validatorForm = new FormGroup({
      isMandatory: new FormControl(),
      isIdentity: new FormControl(),
      isMinimumChecked: new FormControl(),
      MinimumValueValidator: new FormControl(),
      isMaximumChecked: new FormControl(),
      MaximumValueValidator: new FormControl()
    });

    this.validatorForm.valueChanges.pipe(takeUntil(this.unSubscribe$)).subscribe((value) => {
      const requirementValidator = {
        isMandatory : value.isMandatory,
        isIdentity : value.isIdentity,
      };
      if (value.isMinimumChecked) {
        // @ts-ignore
        requirementValidator.MinimumValueValidator = value.MinimumValueValidator;
      }

      if (value.isMaximumChecked) {
        // @ts-ignore
        requirementValidator.MaximumValueValidator = value.MaximumValueValidator;
      }

      this.dynamicFormControl.setValue(requirementValidator);
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  onSubmit(validatorForm: FormGroup) {
    console.log(validatorForm);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
